"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.API = {
    AUTH: "auth",
    REFRESH: "refresh",
    DATA: {
        ENDPOINT: "ds",
    },
    FILES: {
        ENDPOINT: "fs",
    },
    REAL_TIME: {
        ENDPOINT: "/rtc",
        PORT: "",
        PROTOCOL: "wss",
    },
    UMS: {
        ENDPOINT: "ums",
        SIGNUP: "signup",
        USER: "user",
        CHANGEPASSWORD: "changepassword",
    },
    CHANNEL: {
        ENDPOINT: "channel",
    },
    DOMAIN: "com",
    HOST: "app.jexia",
    PORT: 443,
    PROTOCOL: "https",
};
exports.DELAY = 1000 * 60 * 110;
